import styled from 'styled-components';

export const QRCodeElement = styled.canvas`
  width: 300px;
  height: 300px;
`;

export const MFAWrapper = styled.div`
  width: 300px;
  padding-bottom: 16px;
`;
